"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonTapeNodeUtils = void 0;
const common_1 = require("@finley-technologies/common");
const v4_1 = require("zod/v4");
// Create a utility function module
const commonTapeNodeUtils = (nodeType, artifactType, zodSchema) => {
    // Type Guard for Node
    const isNode = (obj) => {
        return obj.metadata.tapeBuilderNodeType === nodeType;
    };
    // Get artifact slug
    const getArtifactSlug = (node) => {
        (0, common_1.finleyAssert)(isNode(node), `must be a ${nodeType} node`);
        return node.configuration.artifactSlug;
    };
    // Get friendly name
    const getFriendlyName = (node) => {
        return getArtifactSlug(node);
    };
    // Type Guard for Config
    const isConfig = (obj) => {
        const result = zodSchema.safeParse(obj);
        if (!result.success) {
            return false;
        }
        return true;
    };
    // Type Guard for Intermediate Record
    const isIntermediateRecord = (obj) => {
        return obj.type === artifactType;
    };
    const getTapeNode = (node) => {
        (0, common_1.finleyAssert)(isNode(node), `must be a ${nodeType} node`);
        return node;
    };
    const getJsonSchema = () => {
        // default schema generated by zod is not compatible with Monaco editor
        // Monaco editor does not support Draft Draft 2020-12 yet.
        return v4_1.z.toJSONSchema(zodSchema, { target: 'draft-7' });
    };
    return {
        isNode,
        getArtifactSlug,
        getFriendlyName,
        isConfig,
        isIntermediateRecord,
        getTapeNode,
        getJsonSchema,
    };
};
exports.commonTapeNodeUtils = commonTapeNodeUtils;
//# sourceMappingURL=commonTapeNode.js.map